import React, { useReducer, useContext } from 'react'
import produce from 'immer'
import layersReducer from './layers'
import mapReducer from './map'
import menuReducer from './menu'
import sideBarRight from './sideBarRight'

export {
  setGenericLayer,
  countryChanged,
  projectChanged,
  priorityChanged,
  layerAdded,
  layerButtonColors,
  layerDeleted,
  layerUpdated,
  layerIcludeNameChanged,
  layerSliderChanged,
  layerVisibilityChanged,
  orderLayersChange,
  layerIncludeValueChanged,
  setFeatures
} from './layers'
export { mouseHoverLayer, setZoom } from './map'
export { accordionChange, indicatorTabChange, externalTabChange } from './menu'
export {
  setDataTable,
  setFeaturesDataTable,
  sideBarRightVisibilityChanged,
  loadingIssues
} from './sideBarRight'

export { loggerBefore, loggerAfter } from './logger'

// context
export const GlobalContext = React.createContext()

export const useGlobalContext = () => useContext(GlobalContext)

// Global
export const languageChanged = (language) => ({
  type: languageChanged.toString(),
  payload: language
})
languageChanged.toString = () => 'global/languageChanged'

export const initialState = {
  genericLayer: {
    id: 'pilares',
    name: 'Todos los pilares',
    color: '#f15b4e',
    render: 'Option',
    style: {
      prop: 'circle-radius',
      value: ['interpolate', ['linear'], ['zoom'], 5, 3, 6, 5]
    },
    icon: 'todos_pilares.png',
    type: 'secondChildren',
    queryRedmine: [...new Array(100).keys()].map((v) => v.toString()),
    query:
      // eslint-disable-next-line max-len
      'https://geoportal.cepal.org/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typename=geonode%3Apdi&outputFormat=json&srs=EPSG%3A4326&srsName=EPSG%3A4326',
    submenu: [],
    country: 'pdi',
    projectType: 'true',
    priority: 'null',
    features: []
  },
  language: 'es',
  layers: [],
  map: {
    zoom: 0,
    markers: []
  },
  sideBarRight: {
    isOpen: true,
    selectedType: 'dataTable',
    dataTable: [],
    featuresDataTable: [],
    loadingIssues: true
  },
  openAccordions: {
    firstChildren: 'pilaresProgPDI',
    main: 'filtroInformacion'
  },
  showSelectedIndicatorLayers: false,
  showSelectedExternalLayers: false
}

export const globalReducer = (globalState, action) => {
  const reducers = {
    ...mapReducer,
    ...menuReducer,
    ...layersReducer,
    ...sideBarRight,
    [languageChanged]: (draftState, language) => {
      draftState.language = language
    }
  }

  const reducer = produce(reducers[action.type])

  window.reduxState = reducer
    ? reducer(globalState, action.payload)
    : globalState
  return window.reduxState
}

export const useGlobalReducer = (middlewaresBeffore, middlewaresAfter) => {
  const [state, dispatch] = useReducer(globalReducer, initialState)

  const dispatchWithMiddleware = (action) => {
    middlewaresBeffore?.forEach((middlewareFn) =>
      middlewareFn({ action, state })
    )
    dispatch(action)
    middlewaresAfter?.forEach((afterwareFn) =>
      afterwareFn({ action, state: window.reduxState })
    )
  }

  return [state, dispatchWithMiddleware]
}

/// ////
export const getLanguage = () => window?.reduxState?.language
